/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon';
icon.register({
	'paused-rounded': {
		width: 20,
		height: 20,
		viewBox: '0 0 20 20',
		data: '<path d="M10 0C4.477 0 0 4.477 0 10C0 15.523 4.477 20 10 20C15.523 20 20 15.523 20 10C20 4.477 15.523 0 10 0ZM8 14C7.448 14 7 13.552 7 13V7C7 6.448 7.448 6 8 6C8.552 6 9 6.448 9 7V13C9 13.552 8.552 14 8 14ZM12 14C11.448 14 11 13.552 11 13V7C11 6.448 11.448 6 12 6C12.552 6 13 6.448 13 7V13C13 13.552 12.552 14 12 14Z" fill="#22262A"/>'
	}
});
